module.exports = __webpack_public_path__ + "static/media/20190826_154142.thumbnail.f6b84116.png";